const PCLN_GRAPH_URL = '/pws/v0/pcln-graph/'

const GRAPH_CDN_PROD = 'https://graphcdn.priceline.com'

const GRAPH_CDN_QA = 'https://graphcdn-qaa.priceline.com'

const GRAPH_CDN_SETI = {
  airPriceGuideRetailOW: 'AIR_PCLN_GRAPH_CDN_OW',
  airPriceGuideRetailRT: 'AIR_PCLN_GRAPH_CDN_RT',
}

export { PCLN_GRAPH_URL, GRAPH_CDN_PROD, GRAPH_CDN_QA, GRAPH_CDN_SETI }
